/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from "react";
import { connect } from "react-redux";
import containsLongRunningProcess from "components/hoc/containsLongRunningProcess";
import requireAuth from "components/hoc/requireAuth";
import Employee from "components/employeeManagement/Employee";
import CreateEmployee from "components/employeeManagement/CreateEmployee";
import Pagination from "react-js-pagination";
import DesktopBreakpoint from "util/responsive/desktop_breakpoint";
import { Trans } from "react-i18next";
import i18next from "i18next";
import Helpers from "util/helpers";
import { getEmployees, showModal } from "actions";
import { api } from "api";

class Employees extends Component {
  state = {
    filteredEmployeesData: [],
    filterTerm: "",
    activePage: 1,
    sort_by: "trFullname",
    sort_dir: "desc",
    page_title: <Trans desc="Employee List">employee_list</Trans>,
    page_type: true,
    dismiss_count: 0
  };

  settings = {
    itemsPerPage: 10,
  };

  componentDidMount() {
    this.setState({ filteredEmployeesData: this.props.data.employees });

    this.dismissCount();
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.data !== this.props.data) {
      this.setState({ filteredEmployeesData: this.props.data.employees });
    }

    if (this.state.filterTerm !== prevState.filterTerm) {
      this.setState({
        filteredEmployeesData: this.props.data.employees.filter((item) => {
          return (
            Helpers.getTurkishCharaterFixedList(item.fullname ?? "").includes(
              Helpers.getTurkishCharaterFixedList(this.state.filterTerm)
            ) ||
            Helpers.getTurkishCharaterFixedList(item.position.name).includes(
              Helpers.getTurkishCharaterFixedList(this.state.filterTerm)
            ) ||
            Helpers.getTurkishCharaterFixedList(
              item.emailAddress ?? ""
            ).includes(
              Helpers.getTurkishCharaterFixedList(this.state.filterTerm)
            )
          );
        }),
      });
    }
  }

  handlePageChange = (pageNum) => {
    this.setState({ activePage: pageNum });
  };

  handleFilter = (e) => {
    this.setState({ filterTerm: e.target.value });
  };

  openCreateEmployeeModal = (training) => {
    this.props.showModal({
      modalType: "createEmployeeModal",
      modalTitle: i18next.t("10559"),
      modalContent: <CreateEmployee />,
      modalFooter: null,
      modalCustomClassName: "modal-xl ttModal",
    });
  };




  renderSearchBar = () => {
    return (
      <div className="col-xs-12 col-sm-12 col-md-3 col-lg-4 tableSearchArea">
        <div className="inner-addon right-addon">
          <span className="iconmford fo-icon-search"></span>
          <input
            type="text"
            name="tableSearch"
            id="tableSearch"
            className="form-control"
            placeholder={i18next.t("10053")}
            onChange={(e) => this.handleFilter(e)}
            value={this.state.filterTerm}
          />
        </div>
      </div>
    );
  };

  renderHeaderToolbar = () => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginRight: "10px",
        }}
      >
        {this.renderSearchBar()}

        <Pagination
          hideFirstLastPages={true}
          prevPageText={i18next.t(10110)}
          nextPageText={i18next.t(10111)}
          hideDisabled={true}
          hideNavigation={true}
          activePage={this.state.activePage}
          itemsCountPerPage={this.settings.itemsPerPage}
          totalItemsCount={
            this.state.filteredEmployeesData?.length > 0
              ? this.state.filteredEmployeesData.length
              : 0
          }
          onChange={(e) => this.handlePageChange(e)}
          itemClass="page-item"
          linkClass="page-link"
        />
      </div>
    );
  };

  renderFooterToolbar = () => {
    return (
      <div className="table-footer-toolbar">
        {/* <button className="export-button" onClick={this.handleExportCSV}>
          <Trans desc="Dışa Aktar">10113</Trans>
        </button> */}
      </div>
    );
  };

  trFullname = "";
  trPosition = "";
  trEmailAddress = "";
  trApprovel = "";

  reOrder = (orderBy) => {
    let sort_dir = "asc";
    if (this.state.sort_dir === "asc") sort_dir = "desc";
    this.setState({
      sort_by: orderBy,
      sort_dir: sort_dir,
    });
  };

  setSotingClassNames = () => {
    this.trFullname = "";
    this.trPosition = "";
    this.trEmailAddress = "";
    this.trApprovel = "";

    switch (this.state.sort_by) {
      case "trFullname":
        this.trFullname = `_${this.state.sort_dir}`;
        break;
      case "trPosition":
        this.trPosition = `_${this.state.sort_dir}`;
        break;
      case "trEmailAddress":
        this.trEmailAddress = `_${this.state.sort_dir}`;
        break; 
      case "trApprovel":
        this.trApprovel = `_${this.state.sort_dir}`;
        break;
      default:
        this.trFullname = `_${this.state.sort_dir}`;
        break;
    }
  };

  renderData = (start, end) => {
    const sorted = this.state.filteredEmployeesData.sort((a, b) => {
      switch (this.state.sort_by) {
        case "trFullname":
          return this.state.sort_dir === "desc"
            ? a.fullname.localeCompare(b.fullname)
            : b.fullname.localeCompare(a.fullname);
        case "trPosition":
          return this.state.sort_dir === "desc"
            ? a.position?.name.localeCompare(b.position?.name)
            : b.position?.name.localeCompare(a.position?.name);
        case "trEmailAddress":
          return this.state.sort_dir === "desc"
            ? (a.emailAddress ?? "").localeCompare(b.emailAddress ?? "")
            : (b.emailAddress ?? "").localeCompare(a.emailAddress ?? ""); 
       case "trApprovel":
  return this.state.sort_dir === "desc"
    ? (Number(a.organizationInfo) || 0) - (Number(b.organizationInfo) || 0)
    : (Number(b.organizationInfo) || 0) - (Number(a.organizationInfo) || 0);
        default:
          return this.state.sort_dir === "desc"
            ? a.fullname.localeCompare(b.fullname)
            : b.fullname.localeCompare(a.fullname);
      }
    });

    return sorted.slice(start, end).map((employee) => {
      return <Employee key={employee.key} employee={employee} page_type={this.state.page_type} employeelist={this.employeelist} />;
    });
  };


  employeelist = () => {

    api
      .get(`/api/employee-management/employees`)
      .then((response) => {

        this.setState({ filteredEmployeesData: response.data.data.employees });

      })
      .catch((err) => {
        console.error(err);
      });

    this.setState({ page_title: <Trans desc="Employee List">employee_list</Trans> });
    this.setState({ page_type: true });
    this.dismissCount();

  };

  dismisslist = () => {

    api
      .get(`/api/employee-management/reactiveemployees`)
      .then((response) => {

        this.setState({ filteredEmployeesData: response.data.data.employees });
        this.setState({ dismiss_count: response.data.data.employees.length });
      })
      .catch((err) => {
        console.error(err);
      });

    this.setState({ page_title: <Trans desc="Terminated Employee">terminated_employee</Trans> });
    this.setState({ page_type: false });
  };

  dismissCount = () => {

    api
      .get(`/api/employee-management/reactiveemployees`)
      .then((responseCount) => {

        this.setState({ dismiss_count: responseCount.data.data.employees.length });

      })
      .catch((err) => {
        console.error(err);
      });

  };




  render() {
    let start = this.settings.itemsPerPage * (this.state.activePage - 1);
    let end = start + this.settings.itemsPerPage;

    this.setSotingClassNames();

    return (
      <>
        {this.props.spinner}
        <div className="row pb-2">
          <div className="col-xs-9 col-sm-9 col-md-9 col-lg-9 text-left">
            <div
              className="col-xs-12 col-sm-12 col-md-12 col-lg-12"
              style={{ display: "block", marginBottom: "10px" }}
            >
              <button
                className="btn-action btn-blue"
                style={{ width: "auto", marginRight: "5px" }}
                onClick={() => this.openCreateEmployeeModal()}
              >
                <Trans desc="Yeni Çalışan Ekle">10559</Trans>
              </button>

              <button
                data-toggle="tooltip"
                data-placement="bottom"
                title={this.state.page_type ? " Count ( " + this.state.filteredEmployeesData.length + " )" : ""}
                className={!this.state.page_type ? "btn-action btn-blue" : "btn-action btn-orange"}
                style={{ width: "auto", marginRight: "5px" }}
                onClick={() => this.employeelist()}
              >
                <Trans desc="Employee List">employee_list</Trans>
              </button>

              <button
                data-toggle="tooltip"
                data-placement="bottom"
                title={!this.state.page_type ? " Count ( " + this.state.filteredEmployeesData.length + " )" : ""}
                className={this.state.page_type ? "btn-action btn-blue" : "btn-action btn-orange"}
                style={{ width: "auto" }}
                onClick={() => this.dismisslist()}
              >
                <Trans desc="Terminated Employee">terminated_employee</Trans>
              </button>

              <span style={{ marginLeft: "10px" }}> {this.state.page_title} {" ( " + this.state.filteredEmployeesData.length + " )"}</span>

            </div>
          </div>
          <div className="col-xs-3 col-sm-3 col-md-3 col-lg-3 text-right">
            <div >
              <span className="iconmford fo-icon-info" style={{ color: "orange", fontSize: "18px", marginRight: "5px" }}></span>
              <Trans desc="Terminated Employee">terminated_employee</Trans> ( {this.state.dismiss_count} )
            </div>
          </div>
        </div>

        <div>{this.renderHeaderToolbar()}</div>
        <div
          className="col-xs-12 col-sm-12 col-md-12 col-lg-12"
          id="calisanRolleri"
          style={{ display: "block" }}
        >
          <table
            className="table display responsive dataTable no-footer dtr-none collapsed"
            id="dataTablePersonel"
          >
            <thead>
              <tr>
                <th
                  onClick={() => this.reOrder("trFullname")}
                  className={`all sorting${this.trFullname}`}
                >
                  <div className="tableTitle">
                    <Trans desc="Ad Soyad">10560</Trans>
                  </div>
                </th>
                <th
                  onClick={() => this.reOrder("trPosition")}
                  className={`all sorting${this.trPosition}`}
                >
                  <div className="tableTitle">
                    <Trans desc="Pozisyon">10561</Trans>
                  </div>
                </th>
                <DesktopBreakpoint>
                  <th
                    onClick={() => this.reOrder("trEmailAddress")}
                    className={`desktop sorting${this.trEmailAddress}`}
                  >
                    <div className="tableTitle">
                      <Trans desc="E-Posta Adresi">10562</Trans>
                    </div>
                  </th>
                  <th className="desktop">
                    <div className="tableTitle">
                      <Trans desc="Dil Tercihi">
                        employeemanagement_preferred-language
                      </Trans>
                    </div>
                  </th>
                   <th   onClick={() => this.reOrder("trApprovel")}  className={`desktop sorting${this.trApprovel}`}
                  >
                   
                    <div className="tableTitle">
                      <Trans desc="Approval Status">
                        approvalStatus
                      </Trans>
                    </div>
                  </th>
                  <th className="none" ></th>
                  <th className="none" ></th>
                  <th className="none" ></th>
                  <th className="none" ></th>
                  <th className="none" ></th>
                  <th className="none" ></th>
                </DesktopBreakpoint>
              </tr>
            </thead>
            <tbody>{this.renderData(start, end)}</tbody>
          </table>
        </div>
        <div>
          <hr />
          {this.renderFooterToolbar()}
        </div>
      </>
    );
  }
}

const mapStateToProps = ({ application }) => {
  return {
    application,
  };
};

export default connect(mapStateToProps, {
  getEmployees,
  showModal,
})(containsLongRunningProcess(requireAuth(Employees)));
